import { Injectable } from '@angular/core'; 
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MeasurementUnit } from 'app/models/umedida.models';

@Injectable({
  providedIn: 'root'
})
export class UmedidaService {


  umedidas: Observable<MeasurementUnit[] | any>;

  constructor(private http: HttpClient) { }

  getUmedidas(): Observable<MeasurementUnit | any> {
    return this.umedidas = this.http.get(environment.apiUrl + 'measurement-unit');
  }


}
